import { Link } from "react-router-dom";

interface EmptyStateProps {
  icon?: string;
  title: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
  to?: string;
}

export default function EmptyState({
  icon = "ri-inbox-line",
  title,
  description,
  actionLabel,
  onAction,
  to,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-background-300 bg-background-50 px-6 py-16 text-center animate-fade-in">
      <span className="flex h-16 w-16 items-center justify-center rounded-full bg-secondary-100 text-secondary-700">
        <i className={`${icon} text-3xl`}></i>
      </span>
      <p className="mt-4 text-base font-semibold text-foreground-900">{title}</p>
      {description && (
        <p className="mt-1.5 max-w-md text-sm text-foreground-500">{description}</p>
      )}
      {actionLabel && to && (
        <Link
          to={to}
          className="mt-5 inline-flex items-center gap-1.5 rounded-md bg-primary-500 px-5 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
        >
          {actionLabel}
          <i className="ri-arrow-right-line"></i>
        </Link>
      )}
      {actionLabel && onAction && (
        <button
          type="button"
          onClick={onAction}
          className="mt-5 inline-flex items-center gap-1.5 rounded-md bg-primary-500 px-5 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-refresh-line"></i>
          {actionLabel}
        </button>
      )}
    </div>
  );
}